module.exports = __webpack_public_path__ + "static/img/index4(1)_13.426ed7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index4(1)_13.png
// module id = 3134
// module chunks = 1